import React from 'react';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import { changeEventFilter } from '../../../../../store/actions/sportEvents';
import { getTranslation } from '../../../../../utils/translation';
import { LANGUAGES } from '../../../../../constants/defaultValues';

import styles from './Categories.module.scss';

const Categories = props => {
    const dispatch = useDispatch();

    const locale = useSelector(state => state.settings.locale);
    const categories = useSelector(state => state.sportEvents.filters.categories) || [];

    const options = categories.map(category => {
        const categoryName =
            category.label || category.names[locale] || category.names[LANGUAGES.eng];

        return {
            value: category.id,
            label: (
                <div className={styles.options}>
                    {category.countryCode && (
                        <div className={styles.flagContainer}>
                            <img
                                alt={category.countryCode}
                                src={`/assets/flags/${
                                    category.countryCode?.trim()
                                        ? category.countryCode.toLowerCase()
                                        : 'int'
                                }.svg`}
                                className={styles.flag}
                            />
                        </div>
                    )}
                    <div>{categoryName}</div>
                </div>
            ),
            data: { categoryName },
            selected: category.selected,
        };
    });

    const selectedOption = options.find(option => option.selected);

    const onChange = value => {
        if (value.value === selectedOption.value) return;

        if (props.onChange) {
            props.onChange(value);
        }

        const newCategories = categories.map(category => ({
            ...category,

            selected: category.id === value.value,
        }));

        dispatch(changeEventFilter({ key: 'categories', value: newCategories }));
    };

    const filterOptions = ({ value, label, data: option }, keyword) => {
        keyword = keyword.toLowerCase();

        const { data } = option;
        const categoryName = data.categoryName.toLowerCase();

        return !keyword || categoryName.includes(keyword);
    };

    return (
        <Select
            className='common-select common-select--events'
            classNamePrefix='common'
            menuPlacement={'auto'}
            value={selectedOption}
            onChange={onChange}
            options={options}
            noOptionsMessage={getTranslation('noOptionsMessage')}
            filterOption={filterOptions}
        />
    );
};

export default Categories;
